import * as React from 'react';
import './index.less';
import { connect } from 'dva';
import { Menu } from 'antd';
import ABSIcon from '../ABSIcon';
import ABSLink from '../ABSLink';
import ABSPerfectScrollBar from '../ABSPerfectScrollBar';
import commonUtils from '../../utils/commonUtils';
import { getOpenKeys, getSelectedKey } from './utils';

const SubMenu = Menu.SubMenu;

export interface IABSSidebarMenuData {
  icon: string;
  name: string;
}

interface IABSSidebarProps {
  location?: any;
  menus?: any;
  prefix?: string;
  securityID?: number | null;
  dealID?: number | null;
  organizationID?: number | null;
  apiId?: number | null;
  reitsID?: number | null;
}

interface IABSSidebarState {
  openKeys: string[];
  menus: any[];
}

const mapStateToProps = state => {
  const securityID = commonUtils.getValue(state, 'investment.pageHeader.security_id', null);
  const reitsID = commonUtils.getValue(state, 'product.reitsID', null);
  const dealID = commonUtils.getValue(state, 'product.dealID', null);
  const organizationID = commonUtils.getValue(state, 'organization.organizationCore.id', null);
  const apiId = commonUtils.getValue(state, 'openapi.apiId', null);
  return {
    securityID,
    dealID,
    organizationID,
    apiId,
    reitsID
  };
};

// 如果pure为true 则会默认进行一次浅比较 但是对应点击的左侧菜单不会高亮
@connect(
  mapStateToProps,
  null,
  null,
  { pure: false }
)
class ABSSidebar extends React.Component<IABSSidebarProps, IABSSidebarState> {
  static defaultProps = {
    prefix: ''
  };

  state = {
    openKeys: [],
    menus: []
  };

  static getDerivedStateFromProps(nextProps: IABSSidebarProps, prevState: IABSSidebarState) {
    const menus = nextProps.menus;
    const lastMenus = prevState.menus;
    const nextOpenKeys = getOpenKeys(menus);
    if (lastMenus.length !== menus.length) {
      return {
        openKeys: nextOpenKeys,
        menus
      };
    }
    return null;
  }

  onOpenChange = (openKeys: string[]) => {
    this.setState({ openKeys });
  };

  renderIcon(item: IABSSidebarMenuData) {
    return (
      <span>
        <span>
          <ABSIcon type={item.icon} />
          <span>{item.name}</span>
        </span>
      </span>
    );
  }

  renderUrl(item: any) {
    const { securityID, dealID, organizationID, apiId, reitsID } = this.props;
    if (securityID) {
      return `${item.url}?security_id=${securityID}`;
    }

    if (reitsID && item.url.includes('reits')) {
      return `${item.url}?reits_id=${reitsID}`;
    }
    if (dealID) {
      return `${item.url}?deal_id=${dealID}`;
    }
    if (organizationID) {
      return `${item.url}?organization_id=${organizationID}`;
    }
    if (item.url.includes('openapi.html#/detail')) {
      return `${item.url}?id=${apiId}`;
    }
    return item.url;
  }

  renderIndex(parentIndex: number, index: number) {
    const showIndex = location.href.includes('absui.html');
    if (showIndex && parentIndex !== undefined && parentIndex !== undefined) {
      return (
        <>
          {parentIndex + 1}.{index + 1}.
        </>
      );
    }
    return null;
  }

  renderMenu = (menus, menuIndex?) => {
    if (menus && menus.length > 0) {
      return menus.map((item, index) => {
        let key = item.url ? item.url.trim() : item.key;

        if (item.children && item.children.length > 0) {
          return (
            <SubMenu title={this.renderIcon(item)} key={key}>
              {this.renderMenu(item.children, index)}
            </SubMenu>
          );
        }
        const url = this.renderUrl(item);
        if (location.href.includes('absui.html')) {
          key = `${location.pathname}#${key}`;
        }
        return (
          <Menu.Item key={key}>
            <ABSLink to={url} target="_self">
              <ABSIcon type={item.icon} />
              <span>
                {this.renderIndex(menuIndex, index)}
                {item.name}
              </span>
            </ABSLink>
          </Menu.Item>
        );
      });
    }
    return null;
  };

  render() {
    const { menus } = this.props;
    let selectedKey = getSelectedKey(menus);
    return (
      <ABSPerfectScrollBar className="abs-sidebar-container">
        <Menu
          openKeys={this.state.openKeys}
          onOpenChange={this.onOpenChange}
          mode="inline"
          theme="dark"
          selectedKeys={[selectedKey]}
          inlineIndent={20}
        >
          {this.renderMenu(menus)}
        </Menu>
      </ABSPerfectScrollBar>
    );
  }
}

export default ABSSidebar;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSSidebar/index.tsx